var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    focusable: "false",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-716 -400)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M159.385,69.577a.752.752,0,0,0-.75.753V75.6h-13V70.33a.75.75,0,1,0-1.5,0v5.377a1.4,1.4,0,0,0,1.4,1.4h13.205a1.4,1.4,0,0,0,1.4-1.4V70.33A.752.752,0,0,0,159.385,69.577Z",
    transform: "translate(571.865 338.889)",
    fill: "#000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.213,71.767a1.4,1.4,0,0,0,.926.381c.022,0,.04.012.062.012a.617.617,0,0,0,.062-.012,1.4,1.4,0,0,0,.926-.381l3.078-2.957a.7.7,0,0,0,0-1.019.773.773,0,0,0-1.061,0l-2.255,2.167V61.831a.751.751,0,0,0-1.5,0v8.127l-2.388-2.294a.77.77,0,0,0-1.06,0,.7.7,0,0,0,0,1.019Z",
    transform: "translate(571.865 338.889)",
    fill: "#000"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.55eea3e0.svg";
export { ForwardRef as ReactComponent };